import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': 'Anket takvimi',
       'SUBTITULO': 'Belirli bir aralıkta platformda oluşturulan anketlerin bilgilerine başvurun.',
       'TXT_RANG_DAT':'Bir tarih aralığı girin',
       'BTN_CANC':'İptal',
       'BTN_APLI':'Uygula',
       'MOD_TITT_INFO':'Anket Bilgileri',
       'TXT_NAM_COMPA':'Şirket adı:  ',
       'TXT_NAM_TOKEN':'Anket jetonu:  ',
       'TXT_DAT_LAN':'Lansman tarihi:  ',
       'TXT_DAT_CLOS_CLOS':'Kapanış tarihi:  ',
       'TXT_SUR_STA':'Anket anket durumu:  ',
       'TXT_TIP_SUR':'Ürün tipi:  ',
       'TXT_YEA_SUR':'Anket yılı:  ',
       'ESTATUS':{
         '0':'Etkin değil',
         '1':'Etkin',
         '2':'Kapalı',
       },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
};
